<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">소장품 관리</h2>
            </div>

            <div class="page-section-wrap">
                <section class="page-section">
                    <div>
                        <v-row>
                            <v-col cols="12" lg="6">
                                <h2 class="tit">소장품 관리 컨설팅</h2>
                            </v-col>
                            <v-col cols="12" lg="6">
                                <div class="page-text primary--text">
                                    <p>본 서비스는 기업, 기관, 미술관, 박물관, 문화시설 등에 제공됩니다.</p>
                                    <p>본 서비스는 예술 작품에 대한 기업 및 기관에 방향과 지침을 제공할 수 있으며, 취득 및 처분을 통해 컬렉션의 고유한 가치를 최대한 활용할 수 있는 방법에 대해 조언합니다.</p>
                                    <p style="letter-spacing:-.04em!important;">구두로 설명하는 아래 4가지의 컨설팅은 무료로 진행됩니다. 부담없이 문의해 주시기 바랍니다.</p>
                                    <p>다만, 서류 혹은 문서(보고서) 형식으로 제공받고자 하는 경우에는 유료로 진행됩니다.</p>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
                <v-divider class="grey-cb"></v-divider>

                <section class="page-section">
                    <div class="my-n14 my-md-n20">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-collection-img.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">
                                                    소장품 구입 컨설팅
                                                    <v-divider vertical class="grey-da h-10px mx-6 my-auto mx-md-10"></v-divider>
                                                    <span class="font-weight-regular">Acquisitions</span>
                                                </h4>
                                            </div>
                                            <div>
                                                <p class="page-text">당사에서는 의뢰받은 뮤지엄 및 기업에 대한 소장품을 분석합니다. 이를 통하여,</p>
                                                <ul class="letter-list mt-4 mt-md-6">
                                                    <li><em>-</em><span>부족하거나 보강이 필요한 소장품의 범위 제시</span></li>
                                                    <li><em>-</em><span>미션 및 수집전략에 부합할 수 있는 수집범위 및 특성화 방안</span></li>
                                                    <li><em>-</em><span>소장품 수집의 원칙 및 철학, 예산 및 지역사회 고려사항 등을 제시합니다.</span></li>
                                                </ul>
                                                <p class="page-text mt-4 mt-md-6">이러한 과정을 통하여 의뢰 뮤지엄 및 기업은 최적의 소장품을 취득할 수 있으며, 지속 가능한 조직의 성장을 도모할 수 있습니다.</p>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-collection-img2.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">
                                                    소장품 관리 컨설팅
                                                    <v-divider vertical class="grey-da h-10px mx-6 my-auto mx-md-10"></v-divider>
                                                    <span class="font-weight-regular">Collection Management</span>
                                                </h4>
                                            </div>
                                            <div>
                                                <p class="page-text">당사에서는 소장처 혹은 소장가의 상황 및 여건에 부합되는 최적의 소장품 관리방안을 아래와 같은 내용으로 조언합니다.</p>
                                                <ul class="letter-list mt-4 mt-md-6">
                                                    <li><em>-</em><span>개별 작품에 대한 보관 및 관리 방안</span></li>
                                                    <li><em>-</em><span>소장품 보관 환경 및 시설, 보존 및 보존처리 방안</span></li>
                                                    <li><em>-</em><span>문서 관리 및 시스템 관리 방안</span></li>
                                                </ul>
                                                <p class="page-text mt-4 mt-md-6">이러한 과정을 통하여, 관리비용 절감, 인력 효율화,  방안</p>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-collection-img3.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">
                                                    소장품 처분 컨설팅
                                                    <v-divider vertical class="grey-da h-10px mx-6 my-auto mx-md-10"></v-divider>
                                                    <span class="font-weight-regular">Deaccessioning</span>
                                                </h4>
                                            </div>
                                            <div>
                                                <ul class="letter-list">
                                                    <li><em>-</em><span>코로나 영향으로 국내외의 많은 뮤지엄과 문화기관은 경제적인 어려움을 <br class="d-none d-md-block"/>경험한 바 있습니다.</span></li>
                                                    <li><em>-</em><span>사립 뮤지엄의 컬렉션은 긴박한 경영상의 사유가 발생하였을 경우, 처분할 수 있습니다.</span></li>
                                                    <li><em>-</em><span>이러한 뮤지엄의 컬렉션은 미술시장에 신선한 관심을 불러 일으킬 수 있습니다.</span></li>
                                                    <li><em>-</em><span>캐터옥션에서는 소장품 처분의 사유, 방법, 절차 등에 대한 전문적인 조언을 해 드립니다.</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-collection-img4.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">
                                                    소장품 중장기 전략 컨설팅
                                                    <v-divider vertical class="grey-da h-10px mx-6 my-auto mx-md-10"></v-divider>
                                                    <span class="font-weight-regular">Long Term Strategic Plan</span>
                                                </h4>
                                            </div>
                                            <div>
                                                <ul class="letter-list">
                                                    <li><em>-</em><span>한 번 수집한 소장품은 장구한 기간동안 함께 해야 합니다.</span></li>
                                                    <li><em>-</em><span>현재 보유있는 소장품은 자산관리 및 활용 측면에서 깊이 있는 전략을 수립해야 합니다.</span></li>
                                                    <li><em>-</em><span>캐터옥션의 &lt;소장품 중장기 전략 서비스&gt;는 귀사의 컬렉션 매니지먼트에 새로운 생동감을 부여할 수 있을 것입니다.</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
            </div>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
export default {
    components: {
        ClientPage,
    },
};
</script>

<style lang="scss" scoped>
</style>